/**
 * rest/aiAct.ts — Client API pour le registre AI Act (Ticket 8.0-04)
 */
// ── Service ─────────────────────────────────────────────────────────────────
export class AiActService {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * GET /api/v1/admin/ai-act/register
     * Récupère le registre complet pour audit.
     */
    async getRegister() {
        return this.http.get('/api/v1/admin/ai-act/register', async () => ({
            meta: { framework: 'EU AI Act 2026', reviewer: 'Simulé' },
            generated_at: new Date().toISOString(),
            red_lines_count: 0,
            treatments_count: 1,
            treatments: [
                {
                    id: 'T-01',
                    name: 'Traitement simulé',
                    category: 'minimal',
                    justification: 'Mode simulation actif',
                    technique: ['rag'],
                    data_in: 'docs',
                    data_out: 'text',
                    art6_3_self_assessment: 'not_required',
                    human_oversight: 'none',
                    mitigations: [],
                    internal_score: 0,
                },
            ],
        }));
    }
    /**
     * POST /api/v1/admin/ai-act/classify
     * Test de classification d'un nouvel usage (triage heuristique).
     */
    async classifyUsage(payload) {
        return this.http.post('/api/v1/admin/ai-act/classify', payload, async () => ({
            category: 'minimal',
            justification: 'Simulé',
            red_line_triggered: false,
            art50_required: true,
            self_assessment_63_required: false,
        }));
    }
}
//# sourceMappingURL=aiAct.js.map